// src/routes/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useUser } from "../utils/user-context";

interface ProtectedRouteProps {
  requiresAuth?: boolean;
  allowedRoles?: string[];
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiresAuth = true,
  allowedRoles,
  children,
}) => {
  const { accounts } = useMsal();
  const { role } = useUser();

  const isAuthenticated = accounts.length > 0;

  // If login required but not authenticated
  if (requiresAuth && !isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  // If allowedRoles is specified, enforce role-based access
  if (allowedRoles && (!role || !allowedRoles.includes(role))) {
    return <Navigate to="/not-authorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
